import { makeStyles } from "@material-ui/core";

import { Level } from "./Level";
import { Cooperation } from "../../gardener/gardener.model";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        alignItems: "center",

        "& > *": {
            marginRight: "24px",

            "&:last-child": {
                marginRight: 0,
            },
        },

        [theme.breakpoints.down(1100)]: {
            flexDirection: "column-reverse",

            "& > *": {
                marginRight: 0,
                marginBottom: "24px",

                "&:first-child": {
                    marginBottom: 0,
                },
            },
        },
    },
}));

interface AllLevelsProps {
    cooperationLevel: Cooperation["level"] | null;
}

export const AllLevels = (props: AllLevelsProps) => {
    const classes = useStyles();
    const { cooperationLevel } = props;

    const cooperationLevels: Cooperation["level"][] = ["bronze", "silver", "gold", "platin"];

    return (
        <div className={classes.root}>
            {cooperationLevels.map(x => (
                <Level key={x} cooperationLevel={x} selected={x === cooperationLevel} />
            ))}
        </div>
    );
};
